module.exports = __webpack_public_path__ + "static/img/c5ecdd92c800da56(1).6549164c.png";